import React, { useState, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./routes";

import { CombineProviders } from "./context/combineProvider";
function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <CombineProviders>
      <div className="App">
        <RouterProvider router={router} />

        {/* <Footer /> */}
      </div>
    </CombineProviders>
  );
}

export default App;
